import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const QuickActions = ({ onActionClick, className = '' }) => {
  const quickActions = [
    {
      id: 'recent-search',
      title: 'Búsquedas Recientes',
      description: 'Ver tus últimas verificaciones',
      icon: 'History',
      action: () => onActionClick('recent')
    },
    {
      id: 'bulk-verify',
      title: 'Verificación Masiva',
      description: 'Verifica múltiples boletos a la vez',
      icon: 'List',
      action: () => onActionClick('bulk')
    },
    {
      id: 'download-all',
      title: 'Descargar Todos',
      description: 'Descarga todos tus comprobantes',
      icon: 'Download',
      action: () => onActionClick('download')
    },
    {
      id: 'contact-support',
      title: 'Soporte Técnico',
      description: 'Contacta nuestro equipo de ayuda',
      icon: 'MessageCircle',
      action: () => onActionClick('support')
    }
  ];

  return (
    <div className={`bg-card rounded-xl border border-border p-6 shadow-luxury ${className}`}>
      <div className="text-center mb-6">
        <h3 className="text-xl font-heading font-bold text-gray-800 mb-2">
          Acciones Rápidas
        </h3>
        <p className="text-gray-800 font-caption">
          Herramientas adicionales para gestionar tus boletos
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {quickActions?.map((action) => (
          <div
            key={action?.id}
            onClick={action?.action}
            className="p-4 rounded-lg border border-border hover:border-secondary/50 hover:bg-muted/30 cursor-pointer transition-premium group"
          >
            <div className="flex items-center space-x-3">
              <div className={`p-3 rounded-lg ${
                'bg-gray-800 text-white group-hover:bg-secondary/10 group-hover:text-secondary'
              } transition-premium`}>
                <Icon 
                  name={action?.icon} 
                  size={20} 
                  className="transition-premium" 
                />
              </div>
              <div className="flex-1">
                <h4 className="font-body font-semibold text-gray-800 group-hover:text-secondary transition-premium">
                  {action?.title}
                </h4>
                <p className="text-sm text-gray-800 font-caption">
                  {action?.description}
                </p>
              </div>
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="text-gray-800 group-hover:text-secondary transition-premium" 
              />
            </div>
          </div>
        ))}
      </div>
      {/* Help Section */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="bg-muted/30 rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <Icon name="HelpCircle" size={20} className="text-secondary mt-0.5" />
            <div>
              <h4 className="font-body font-medium text-gray-800 mb-2">
                ¿Necesitas ayuda?
              </h4>
              <p className="text-sm text-gray-800 font-caption mb-3">
                Si tienes problemas para encontrar tus boletos o necesitas asistencia, 
                nuestro equipo está disponible para ayudarte.
              </p>
              <div className="flex flex-col sm:flex-row gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  iconName="Phone"
                  iconPosition="left"
                  onClick={() => window.open('tel:+584121234567')}
                  className="group"
                >
                  <span className="text-gray-800 group-hover:text-secondary transition-colors">
                    Llamar Soporte
                  </span>
                </Button>
                <Button
                  variant="secondary"
                  size="sm"
                  iconName="MessageCircle"
                  iconPosition="left"
                  onClick={() => window.open('https://wa.me/584121234567', '_blank')}
                >
                  WhatsApp
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;